'use strict';

angular.module('selfAccessRequestControllers')

.controller('AdHocPreAuthorizedSystemTypeListController',
            ['$scope', '$state', '$stateParams', 'selfAccessRequestService', 'decisionSystemTypesList',
    function ($scope, $state, $stateParams, selfAccessRequestService, decisionSystemTypesList) {

        // Return if we are not in the right state
        if (!$state.is('selfAccessRequest.adHoc.preAuthorized')) return;

        // If no decisions inside the list return
        if (_.size(decisionSystemTypesList) === 0) return;

        // Go to State selected
        $state.go('selfAccessRequest.adHoc.preAuthorizedBySystemType', {
            systemTypeSlug: decisionSystemTypesList[0].Slug,
            employeeID: $stateParams.employeeID
        }, {location: 'Replace'});

}]);